var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsOtherFolderCheckmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9867 50.6531H50.6534C53.5989 50.6531 55.9867 48.2653 55.9867 45.3198V21.1598C55.9867 18.2143 53.5989 15.8265 50.6534 15.8265H33.3974C32.5113 15.8269 31.6829 15.3872 31.1867 14.6531L27.4534 9.1518C26.9554 8.42075 26.1273 7.98422 25.2427 7.98646H13.32C10.3745 7.98646 7.98669 10.3743 7.98669 13.3198V26.6531",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.472 35.5006C33.1583 40.1869 33.1582 47.7849 28.472 52.4711C23.7857 57.1574 16.1877 57.1574 11.5014 52.4711C6.81514 47.7849 6.81511 40.1869 11.5014 35.5006C13.7518 33.2501 16.8041 31.9858 19.9867 31.9858C23.1693 31.9858 26.2216 33.2501 28.472 35.5006",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0721 41.435L18.9654 46.5417L15.9041 43.4777",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsOtherFolderCheckmark);
export default ForwardRef;